import { getStatusText, isSuccess, RequestInfo, ResponseOptions, STATUS_CODE_INFO } from 'angular-in-memory-web-api';
import { ModelError as TenantsModelError } from './tenants/gen';

// Helpers for implementing in-memory versions of our APIs

/**
 * Sets standard properties on a ResponseOptions given a RequestInfo
 * @param options
 * @param ri
 * @returns The response options
 */
export function finishOptions(options: ResponseOptions, { headers, url }: RequestInfo): ResponseOptions {
  options.statusText = getStatusText(options.status);
  options.headers = headers;
  options.url = url;
  if (!isSuccess(options.status)) {
    // A real HttpErrorResponse from the server contains an `error` property, rather than `body`,
    // when a request fails. To match this behavior we have to break the ResponseOptions interface.
    (options as any).error = options.body;
    delete options.body;
  }
  return options;
}

/**
 * Takes a map of status codes (strings) to booleans.
 * Returns the numeric code of the first status whose value is true.
 *
 * @param obj
 * @returns The status code of the status, or `null` if all statuses were `false`
 */
export function getStatusCode(obj: StatusCodesMap): number | null {
  let found = false;
  Object.keys(obj).some(statusCode => {
    if (obj[statusCode]) {
      return found = STATUS_CODE_INFO[statusCode].code;
    }
  });
  return found || null;
}

interface StatusCodesMap {
  [key: string]: boolean;
}

export function newModelError(ri: RequestInfo, statusCode: number): TenantsModelError {
  return {
    error: `Fake error ${statusCode}`,
    message: 'Lorem ipsum blah blah',
    path: ri.url,
    status: statusCode,
    timestamp: new Date().toISOString(),
    traceid: (Math.random().toString(16)).slice(2), // TODO not part of ModelError spec
  };
}
